import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { FormsTable } from "./components/formsTable/formsTable";
import { useSearchForms } from "./hooks/useSearchForms";

type Props = {};

export const ConfigurationFormsPage = (prop: Props) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const searchForms = useSearchForms({ setIsLoading, setError });

	useEffect(() => {
		searchForms();
	}, []);

	return (
		<Grid2
			container
			justifyContent="center"
			alignItems="center"
			style={{ padding: "16px" }}
		>
			<Grid2 style={{ margin: 0 }} size={{ md: 12, xs: 12 }}>
				<Typography
					variant="h5"
					style={{ margin: "0 0 20px", fontWeight: 600 }}
				>
					Forms Settings
				</Typography>
				<Paper
					elevation={1}
					style={{
						width: "100%",
						padding: "10px 0 20px",
						borderRadius: "0.75rem",
					}}
				>
					<FormsTable
						isLoading={isLoading}
						searchForms={searchForms}
						error={error}
						setError={setError}
					/>
				</Paper>
			</Grid2>
		</Grid2>
	);
};
